<template lang="pug">
  .week-day-filter
    .filters
      CheckboxesFilter(
        :value="weekdays"
        v-b-tooltip.hover
        :title="$t('inventory_management.inventory_long_period.weekday_filter.tooltip')"
        @input="$emit('input:weekdays', $event)"
      )
      CheckboxesFilter(
        :value="holidayOptions"
        @input="$emit('input:holiday-options', $event)"
      )
    .week-day-filter-message
      | {{ $t("inventory_management.inventory_long_period.weekday_filter.notification_message") }}
</template>

<script>
  export default {
    components: {
      CheckboxesFilter: () => import("@/components/InventoryManagement/CheckboxesFilter")
    },

    props: {
      weekdays: {
        type: Object,
        default: () => new Object()
      },
      holidayOptions: {
        type: Object,
        default: () => new Object()
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"

  .week-day-filter
    width: 49%

    .filters
      display: flex
      justify-content: space-between

    &-message
      color: $default-gray-medium
      font-size: 0.7rem
      text-align: center
</style>
